import React, { useEffect, useState } from "react";
import { Button, Col, Form, Row, Spinner, Dropdown } from "react-bootstrap";
import { useDispatch } from "react-redux";
import {
  editPesoCompetencia,
  savePesoCompetencia,
} from "../../redux/evaluacion_desempenio/pesoCompetencia/actions";
import toastr from "toastr";
import * as Yup from "yup";

const Compencia = (props) => {
  const [_data, setData] = useState({});
  const [_peso, setPeso] = useState(
    props.pesoCompetencia.data.find((e) => e.competencia === props.item.id)
      ? props.pesoCompetencia.data.find((e) => e.competencia === props.item.id)
          .peso
        ? props.pesoCompetencia.data.find(
            (e) => e.competencia === props.item.id
          ).peso
        : 0
      : 0
  );
  const [_desempenio, setDesempenio] = useState(
    props.pesoCompetencia.data.find((e) => e.competencia === props.item.id)
      ? props.pesoCompetencia.data.find((e) => e.competencia === props.item.id)
          .desempeno_esperado
        ? props.pesoCompetencia.data.find(
            (e) => e.competencia === props.item.id
          ).desempeno_esperado
        : 0
      : 0
  );
  const [count, setCount] = useState(0);
  const [loader, setLoader] = useState(false);
  const [saveLoader, setSaveLoader] = useState(false);
  const [error, setError] = useState("");
  const [formError, setFormError] = useState("");
  const [timer, setTimer] = useState(null);
  const [filter, setFilter] = useState("");
  const dispatch = useDispatch();
  const [totalPesos, setTotalPesos] = useState(0);
  const [_pesoC, setPesoC] = useState(null);

  const [tipoBusqueda, setTipoBusqueda] = useState({
    id: "nombre",
    desc: "Competencia",
  });

  const schema = Yup.object().shape({
    descripcion: Yup.string().ensure().required("**Campo requerido"),
    peso: Yup.number()
      .integer("El número no puede tener decimales.")
      .required("**Campo requerido")
      .min(0, "El número no puedo ser menor a 0"),
  });

  const filters = [{ id: "nombre", desc: "Competencia" }];

  useEffect(() => {
    if (props.pesoCompetencia) {
      const exist = props.pesoCompetencia.data.find(
        (e) => e.competencia === props.item.id
      );
      if (exist) {
        setData(exist);
        setPeso(exist.peso);
        setPesoC(exist.peso);
        setDesempenio(exist.desempeno_esperado);
      } else {
        setData({});
      }
    }
  }, [props.pesoCompetencia]);

  const onSubmit = (data, index) => {
    const existe = props.pesoCompetencia.data.find(
      (e) => e.competencia === data.id
    );
    let _req = {
      peso: parseInt(_peso),
      desempeno_esperado: parseInt(_desempenio),
      periodicidad: parseInt(props.period),
    };

    const _index = props.pesoCompetencia.data.findIndex(
      (e) => e.competencia === props.item.id
    );

    const totalTemp = parseInt(props.totalPesos) + _peso - _pesoC;
    console.log(totalTemp, _pesoC, props.totalPesos, _peso);
    const pesoCategoria = props.pesoCompetencia.data.findIndex(
      (e) => e.clasificacion === props.item.list_clasificacion[0].nombre
    );

    if (totalTemp > 100) {
      toastr.info(
        `La suma total de pesos no puede ser mayor a 100.(total = ${totalTemp})`
      );
      return;
    }
    if (parseInt(_req.desempeno_esperado) > 100) {
      toastr.info("El rendimiento no puede ser mayor a 100");
      return;
    }

    if (parseInt(_req.desempeno_esperado || _req.peso) < 0) {
      toastr.info("El rendimiento y el peso no pueden ser 0");
      return;
    }
    if (!existe) {
      _req.competencia = parseInt(props.item.id);
      _req.clasificacion = parseInt(props.item.clasificacion);
      dispatch(savePesoCompetencia(_req, setError, setSaveLoader));
    } else {
      _req.id = parseInt(existe.id);
      dispatch(editPesoCompetencia(_req, _index, setError, setSaveLoader));
    }

    setPesoC(_peso);
  };

  return (
    <>
      <tr>
        <td>
          <Form.Group as={Row}>
            <Col sm={12}>
              <Form.Control
                name="descripcion"
                className="rounded-pill"
                required
                type="text"
                placeholder="descripcion"
                value={props.item.nombre}
                onChange={() => console.log(props.item)}
                disabled
              ></Form.Control>
            </Col>
          </Form.Group>
        </td>
        <td>
          <Form.Group as={Row}>
            <Col sm={12}>
              <Form.Control
                name="clasificacion"
                className="rounded-pill"
                required
                type="text"
                placeholder="clasificacion"
                value={
                  props.item.list_clasificacion == null
                    ? ""
                    : props.item.list_clasificacion[0].nombre
                }
                onChange={() =>
                  console.log(
                    props.item.list_clasificacion[0].nombre,
                    "viendo que viene de la data"
                  )
                }
                disabled
              ></Form.Control>
            </Col>
          </Form.Group>
        </td>
        <td>
          <Form.Group as={Row}>
            <Col sm={12}>
              <Form.Control
                name="peso"
                className="rounded-pill"
                required
                min={0}
                type="number"
                placeholder="0"
                disabled={saveLoader || props.isClosed}
                // defaultValue={
                //   props.pesoCompetencia.data.find(
                //     (e) => e.competencia === props.item.id
                //   )
                //     ? props.pesoCompetencia.data.find(
                //       (e) => e.competencia === props.item.id
                //     ).peso
                //       ? props.pesoCompetencia.data.find(
                //         (e) => e.competencia === props.item.id
                //       ).peso
                //       : 0
                //     : 0
                // }
                value={_peso}
                onChange={(e) => {
                  const Value = e.currentTarget.value;
                  if (timer) {
                    clearTimeout(timer);
                    setTimer(null);
                  }
                  setTimer(
                    setTimeout(() => {
                      if (
                        (parseInt(Value) >= 0 && parseInt(Value) <= 100) ||
                        Value === ""
                      ) {
                        setPeso(Value === "" ? 0 : parseInt(Value));
                      }
                    }, 100)
                  );
                }}
                //disabled
              ></Form.Control>
            </Col>
          </Form.Group>
        </td>
        <td>
          <Form.Group as={Row}>
            <Col sm={12}>
              <Form.Control
                name="desempeno_esperado"
                className="rounded-pill"
                required
                min={0}
                type="number"
                placeholder="0"
                disabled={saveLoader || props.isClosed}
                // defaultValue={
                //   props.pesoCompetencia.data.find(
                //     (e) => e.competencia === props.item.id
                //   )
                //     ? props.pesoCompetencia.data.find(
                //       (e) => e.competencia === props.item.id
                //     ).desempeno_esperado
                //       ? props.pesoCompetencia.data.find(
                //         (e) => e.competencia === props.item.id
                //       ).desempeno_esperado
                //       : 0
                //     : 0
                // }
                value={_desempenio}
                onChange={(e) => {
                  const Value = e.currentTarget.value;
                  if (timer) {
                    clearTimeout(timer);
                    setTimer(null);
                  }
                  setTimer(
                    setTimeout(() => {
                      if (
                        (parseInt(Value) >= 0 && parseInt(Value) <= 100) ||
                        Value === ""
                      ) {
                        setDesempenio(Value === "" ? 0 : parseInt(Value));
                      }
                    }, 100)
                  );
                }}
                //disabled
              ></Form.Control>
            </Col>
          </Form.Group>
        </td>
        <td>
          <div className="button-group" role="group">
            <Button
              size="sm"
              variant="link"
              type="button"
              disabled={saveLoader || props.isClosed}
              onClick={() => onSubmit(props.item, props.index)}
            >
              {saveLoader ? (
                <Spinner
                  className="mr-2"
                  as="span"
                  animation="border"
                  size="sm"
                  role="status"
                  aria-hidden="true"
                />
              ) : (
                <i className="material-icons" size={12}>
                  save
                </i>
              )}
            </Button>
            <Dropdown.Menu>
              {filters.map((item) => (
                <Dropdown.Item
                  onClick={() => setTipoBusqueda(item)}
                  key={item.id}
                >
                  {item.desc}
                </Dropdown.Item>
              ))}
            </Dropdown.Menu>
          </div>
        </td>
      </tr>
    </>
  );
};

export default Compencia;
